// 二维码生成

const QRCode = require('qrcode')

class QrCode {
  static toQrCode(url) {
    return new Promise((resolve, reject) => {
      QRCode.toDataURL(url, function (err, url) {
        if(err) {
          reject(err);
        }else {
          resolve(url)
        }
      });
    });
  }

  static toCanvas(canvas, url) {
    return new Promise((resolve, reject) => {
      QRCode.toCanvas(canvas, url, function (err, url) {
        if(err) {
          reject(err);
        }else {
          resolve(url)
        }
      });
    });
  }
}

export default QrCode;
